export default __webpack_public_path__ + "static/media/jumbotronBot.2f925e64.jpg";